import React, { useState } from 'react'
import LogoImg from '../../../assets/login/logo.png'
import LeftArrow from '../../../assets/login/left_arrow.svg'

import {
  Container,
  EmailLabel,
  InputButton,
  EmailInput,
  Title,
  Logo,
} from './style'
import { ReturnButton, MainText } from '../style'
import ApiService from '../../../services/ApiService'
import { ErrContainer } from '../MainBox/style'

interface PassResetEmailProps {
  setPage: (page: string) => void
}

const PassResetEmail: React.FC<PassResetEmailProps> = (props) => {
  const [email, setEmail] = useState<string>('')
  const [errStatus, setErrStatus] = useState<number>(0)

  const changePage = (_page: string) => {
    props.setPage(_page)
  }

  const handleSubmit = async () => {
    try {
      await ApiService.auth.resetPassword(email)
      changePage('CodeInput')
      setErrStatus(0)
    } catch (err) {
      console.log(err)
      setErrStatus(500)
    }
  }

  return (
    <Container>
      <Logo src={LogoImg} alt='Logo da Dustre' />
      <Title>
        <ReturnButton
          onClick={() => {
            changePage('Main')
          }}
        >
          <img src={LeftArrow} alt='Botão de retorno ' />
        </ReturnButton>
        <MainText> Esqueci a senha </MainText>
      </Title>

      <form>
        <EmailLabel htmlFor='email'>
          Digite seu email cadastrado na Ordeno para enviarmos um código de
          ativação para redefinição de senha
        </EmailLabel>
        <EmailInput
          type='text'
          name='email'
          placeholder='Seu email'
          id='email'
          onChange={(e) => setEmail(e.target.value)}
        />
        {errStatus === 500 ? <ErrContainer>Email inválido</ErrContainer> : null}
        <InputButton
          type='button'
          value='Entrar'
          // onClick={() => handleSubmit()}
          onClick={() => handleSubmit()}
        />
      </form>
    </Container>
  )
}

export default PassResetEmail
